import Breadcrumb from "../../../components/breadcrumb";

function PresidentesHeader() {
    return (
        <header className="mb-10 md:mb-12">
            <Breadcrumb
                items={[
                    { label: "Inicio", to: "/" },
                    { label: "Presidentes", isCurrent: true },
                ]}
                className="mb-4"
            />

            <h1 className="text-2xl sm:text-4xl md:text-5xl font-black text-white mb-3 border-l-4 border-red-500 pl-4">
                Presidentes
            </h1>
            <p className="text-slate-400 font-medium text-sm sm:text-lg max-w-3xl">
                Listado histórico de los mandatarios que han forjado el camino de nuestra institución.
            </p>
        </header>
    );
}

export default PresidentesHeader;